import MainProject from '@/model/MainProject'

async function yieldToUi(): Promise<void> {
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
  })
}

export type ParseProjectsProgress = (percent: number, status: string) => void

function assertProjectBinBytes(bytes: unknown): asserts bytes is ArrayBuffer | Uint8Array {
  const value = bytes as { byteLength?: unknown; length?: unknown } | null
  const length = typeof value?.byteLength === 'number'
    ? value.byteLength
    : typeof value?.length === 'number'
      ? value.length
      : 0
  if (length <= 0) {
    throw new Error('解析 projects.bin 失败：工程主包数据为空')
  }
}

/**
 * 从云端/内存拿到的 projects.bin 二进制直接解析。
 */
export async function parseProjectsBinFromBytes(
  bytes: ArrayBuffer | Uint8Array,
  onProgress?: ParseProjectsProgress,
): Promise<MainProject> {
  assertProjectBinBytes(bytes)
  const report = onProgress ?? (() => {})
  const mp = new MainProject()
  await mp.readBinBuffer(bytes, async (value, message) => {
    report(value, message)
    await yieldToUi()
  })
  return mp
}
